import SitePropertyUtil from '@lts-web/utils/SitePropertyUtil';

function scrapeFBDefaultCallback (data) {
    console.log('Success: data Scraped', data);
}

function scrapeFacebookData (url, callback, accessToken) {
    var encodedURL = encodeURIComponent(url);

    callback = callback || scrapeFBDefaultCallback;
    accessToken = accessToken || getFacebookAccessToken();

    $.ajax({
        type: 'POST',
        url: 'https://graph.facebook.com?id=' + encodedURL + '&access_token=' + accessToken + '&scrape=true',
        success: function(data){
            callback.call(this, data);
        }
    });
}

function getFacebookAppID () {
    return getFacebookAccessToken().split('|')[0];
}

function getFacebookAccessToken () {
    return SitePropertyUtil.getPropertyValue('GUI', 'FB_ACCESS_TOKEN') || ' | ';
}

global.metadata = {
    promotions: {},
    getFacebookAppID,
    scrapeFacebookData
};